import { Domain } from '@zooplus/commons-lang';

export type SiteBrand = 'zoochic' | 'zoohit' | 'zooplus' | 'bitiba';

/**
 * Determines the site brand based on the provided domain.
 *
 * @param domain - The domain of the site.
 * @returns The corresponding site brand.
 * @throws Will throw an error if the domain does not match any known brands.
 */
export function getSiteBrand(domain: Domain): SiteBrand {
  if (domain.includes('zoochic')) {
    return 'zoochic';
  }
  if (domain.includes('zoohit')) {
    return 'zoohit';
  }
  if (domain.includes('zooplus')) {
    return 'zooplus';
  }
  if (domain.includes('bitiba')) {
    return 'bitiba';
  }
  throw new Error(`Unknown domain: ${domain}`);
}
